import Tasks from 'APP/Tasks';
import { IButtonPayloadModel } from 'STORE/Messages/Message/Payload/ButtonsPayload/ButtonsPayload';
import { ButtonsSelectedPayload } from 'STORE/Messages/Message/Payload/ButtonsSelectedPayload/ButtonsSelectedPayload';

interface IDefaultCommandButtonPresenterProps {
  groupId: string;
  button: IButtonPayloadModel;
}

interface IDefaultCommandButtonPresenter {
  onClick(): void;
}

export const useDefaultCommandButtonPresenter = ({
  button,
  groupId,
}: IDefaultCommandButtonPresenterProps): IDefaultCommandButtonPresenter => {
  const onClick = (): void => {
    Tasks.messaging.createNewMessages(groupId, [
      {
        payload: new ButtonsSelectedPayload({
          button: { title: button.title, id: button.id },
        }),
      },
    ]);
  };

  return { onClick };
};
